const actions = {
  SET_QUESTIONNAIRE: "SET_QUESTIONNAIRE",
  RESET: "RESET",
  SAVE_CHOICE: "SAVE_CHOICE",
  ADD_RANKING: "ADD_RANKING",
  CHANGE_STEP: "CHANGE_STEP",
  LOAD_DATA: "LOAD_DATA",
  SET_PRIORITIZED_YES_INDEXES: "SET_PRIORITIZED_YES_INDEXES",
  REMOVE_RANKING_AND_INDEXES: "REMOVE_RANKING_AND_INDEXES",
};

export default actions;
